import { Component, OnDestroy, OnInit } from '@angular/core';
import { GoogleStreetViewService } from '../../../services/google-street-view.service';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'ebw-google-street-view',
  templateUrl: './google-streetview-control.component.html',
  styleUrls: ['./google-streetview-control.component.scss']
})
export class GoogleStreetViewControlComponent implements OnInit, OnDestroy {

  streetViewTooltip = "";
  streetViewEnabled = false;

  constructor(
    public mapService: MapService,
    public streetViewService: GoogleStreetViewService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
      
  }

  toggleStreetView(){
    this.streetViewService.isActive = !this.streetViewService.isActive;    
  }

}
